import { getText } from '../i18n';

function AboutPage() {
  return (
    <div>
      <h1 className="display-4">{getText('msg_2891eeab416e')}</h1>
    </div>
  );
}

export default AboutPage;
